/** Append a trailing slash to the path part of an internal URL (keeps ?query and #hash). */
export function withTrailingSlash(to) {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) {
    return to;
  }
  const match = /^([^?#]*)(.*)$/.exec(to);
  const path = match[1];
  if (!path || path.endsWith("/")) return to;
  return `${path}/${match[2]}`;
}

export function slashTo(to) {
  if (typeof to === "string") return withTrailingSlash(to);
  if (to && typeof to === "object" && typeof to.pathname === "string") {
    return { ...to, pathname: withTrailingSlash(to.pathname) };
  }
  return to;
}
